import { array, assign, boolean, enums, integer, nullable, object, string } from 'superstruct';
import { stringDate } from '@arc/shared/util-superstruct';
const DEPLOYMENT_STATUSES = ['QUEUED', 'PENDING', 'SUCCESS', 'FAILURE'];
export const ViewArcRoleListDto = object({
  id: integer(),
  name: string(),
  updatedAt: stringDate(),
  createdAt: stringDate(),
  archived: boolean()
});
export const ViewArcRoleDto = assign(ViewArcRoleListDto, object({
  groupIds: array(integer()),
  latestDeployment: nullable(object({
    id: integer(),
    status: enums(DEPLOYMENT_STATUSES),
    totalMembers: integer(),
    processedMembers: integer(),
    startedAt: nullable(stringDate()),
    finishedAt: nullable(stringDate())
  }))
}));